module.exports = __webpack_public_path__ + "assets/3d618703fe555801056aeaaff7a903cd.png";